import { SeparativeLine as SeparativeLineLib } from '@ppay/client'
import styled from 'styled-components'

export const SeparativeLine = styled(SeparativeLineLib)`
  background-color: ${({ theme }) => theme.colors.tertiaryShade2};
  margin: 20px 0;
`
